import { Box, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  default as EnvConfig,
  default as ENVConfig,
} from "../../../config/env.config.json";
import { RoutingURLs } from "../../../config/RoutingURLs";
import { operationsInProcess } from "../../../enums";
import { customerGroup } from "../../../features/account/accountSlice";
import { GetCustomer } from "../../../features/checkout/checkoutSlice";
import { gaCategory } from "../../../Types/GoogleAnalytics";
import { useNonInitialEffect } from "../../../utils/commonFunctions";
import { gtmTagManager } from "../../../utils/commonFunctions/GtmTagManager";
import { ButtonCust } from "../../widgets";
import { paymentLandingProps } from "./PaymentLandingComponent";

enum paymentSuccess {
  PAY_PROGRESS = "PAY_PROGRESS",
  PAY_DONE = "PAY_DONE",
  SHIPMENT_PROGRESS = "SHIPMENT_PROGRESS",
}

const T5PaymentLanding = (props: paymentLandingProps) => {
  const [showPaymentLoading, setShowPaymentLoading] = useState(true);
  const [showPaymentProcess, setShowPaymentProcess] = useState(
    paymentSuccess.PAY_PROGRESS
  );
  const initialPayDone = useRef(true);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location: any = useLocation();
  const formRef = useRef<HTMLFormElement>(null);
  const { group } = useAppSelector((state: any) => state.account);
  const [secondaryPaymentFail, setSecondaryPaymentFail] = useState(false);
  const isSecondaryPaymentFailed = useRef(false);
  const { getCustomer, getCustomerLoading } = useAppSelector(
    (state: any) => state.checkout
  );
  const { globalVal } = useAppSelector(
    (state: any) => state?.strapi?.globalValues || {}
  );
  let currentdetails: any = localStorage.getItem("customerDetail");
  currentdetails = currentdetails ? JSON.parse(currentdetails) : null;
  let initialPurchase: any = localStorage.getItem("initalPurchase");
  let ssoCustomerInfo: any;
  if (ENVConfig.IS_SSO_LOGIN) {
    ssoCustomerInfo = localStorage.getItem("ssoCustomerInfo");
  } else {
    ssoCustomerInfo = localStorage.getItem("currentuser");
  }
  ssoCustomerInfo = JSON.parse(ssoCustomerInfo);

  const handleContinueToDashBoard = () => {
    localStorage.removeItem("initalPurchase");
    localStorage.removeItem("addLineCIds");
    if (location?.state?.redirectionURL) {
      navigate(location?.state?.redirectionURL);
    } else {
      navigate(RoutingURLs.myAccount);
    }
    gtmTagManager({
      event: globalVal?.gtmEvents?.continueToDashboard,
      click_section: "checkout",
    });
  };
  const retryPayment = () => {
    if (formRef.current) {
      formRef.current.submit();
    }
  };
  const { content, loader } = props;
  const { btn_txt, purchase_img } = content;

  const { pur_msg1, pur_msg2, pur_msg3 } = content?.order_details;

  useEffect(() => {
    if (currentdetails) {
      dispatch(
        GetCustomer({
          username: encodeURIComponent(
            currentdetails && currentdetails.emailId
          ),
        })
      );
    }
  }, []);

  useNonInitialEffect(() => {
    if (getCustomer) {
      if (
        getCustomer?.operationsInProcess?.includes(
          operationsInProcess.PAYMENT_CALLBACK_IN_PROCESS
        ) ||
        getCustomer?.operationsInProcess?.includes(
          operationsInProcess.SHIPMENT_PURCHASE_IN_PROGRESS
        ) ||
        getCustomer?.operationsInProcess?.includes(
          operationsInProcess.MIA_IN_PROCESS
        )
      ) {
        setShowPaymentLoading(true);
        if (
          getCustomer?.operationsInProcess?.includes(
            operationsInProcess.PAYMENT_CALLBACK_IN_PROCESS
          )
        ) {
          setShowPaymentProcess(paymentSuccess.PAY_PROGRESS);
        } else if (
          !getCustomer?.operationsInProcess?.includes(
            operationsInProcess.PAYMENT_CALLBACK_IN_PROCESS
          ) &&
          getCustomer?.operationsInProcess?.includes(
            operationsInProcess.SHIPMENT_PURCHASE_IN_PROGRESS
          )
        ) {
          if (initialPayDone.current) {
            setTimeout(
              () => setShowPaymentProcess(paymentSuccess.PAY_DONE),
              2000
            );
            setTimeout(() => {
              setShowPaymentProcess(paymentSuccess.SHIPMENT_PROGRESS);
              initialPayDone.current = false;
            }, 5000);
          } else {
            setShowPaymentProcess(paymentSuccess.SHIPMENT_PROGRESS);
          }
        }
        callGetCustomer();
      } else {
        if (!isSecondaryPaymentFailed.current) {
          setShowPaymentLoading(true);
          dispatch(
            customerGroup({
              groupId: getCustomer?.groupId,
            })
          );
        }
      }
    }
  }, [getCustomer]);

  useNonInitialEffect(() => {
    if (getCustomerLoading) setShowPaymentLoading(true);
  }, [getCustomerLoading]);

  useNonInitialEffect(() => {
    if (group?.data && group?.data.length > 0) {
      let addLineUser: any;
      let addLineCIds: any = localStorage.getItem("addLineCIds");
      if (addLineCIds) addLineCIds = JSON.parse(addLineCIds);
      addLineUser = group?.data?.find((user: any) =>
        addLineCIds?.includes(user.id)
      );
      //Payment Landing loaded after Add line
      if (addLineUser?.simPaid === true) {
        setSecondaryPaymentFail(false);
        setShowPaymentLoading(false);
      } else if (addLineUser?.simPaid === false) {
        if (
          !getCustomer?.operationsInProcess?.includes(
            operationsInProcess.PAYMENT_CALLBACK_IN_PROCESS
          ) ||
          !getCustomer?.operationsInProcess?.includes(
            operationsInProcess.SHIPMENT_PURCHASE_IN_PROGRESS
          )
        ) {
          isSecondaryPaymentFailed.current = true;
          setTimeout(() => {
            setShowPaymentLoading(false);
            setSecondaryPaymentFail(true);
          }, 10000);
        }
      }
    }
    //Payment Landing loaded after retry payment in addline
    if (location?.state?.emailId) {
      let currentUser = group?.data?.find(
        (user: any) => user.emailId === location?.state?.emailId
      );
      if (currentUser?.simPaid) {
        setShowPaymentLoading(false);
        setSecondaryPaymentFail(false);
      } else if (!currentUser?.simPaid) {
        isSecondaryPaymentFailed.current = true;
        setShowPaymentLoading(false);
        setTimeout(() => {
          setSecondaryPaymentFail(true);
        }, 10000);
      }
    }

    // if multiple initial purchase are made
    let initialPurchase = localStorage.getItem("initalPurchase");
    if (initialPurchase === "yes" && getCustomer?.simPaid) {
      setSecondaryPaymentFail(false);
      if (
        getCustomer?.operationsInProcess?.includes(
          operationsInProcess.PAYMENT_CALLBACK_IN_PROCESS
        ) ||
        getCustomer?.operationsInProcess?.includes(
          operationsInProcess.SHIPMENT_PURCHASE_IN_PROGRESS
        )
      ) {
        setShowPaymentLoading(true);
      } else {
        if (initialPayDone.current) {
          setTimeout(() => setShowPaymentProcess(paymentSuccess.PAY_DONE), 2000);
          setTimeout(
            () => setShowPaymentProcess(paymentSuccess.SHIPMENT_PROGRESS),
            5000
          );
          setTimeout(() => setShowPaymentLoading(false), 8000);
          initialPayDone.current = false;
        }
      }
    } else if (initialPurchase === "yes" && !getCustomer?.simPaid) {
      if (
        getCustomer?.operationsInProcess?.includes(
          operationsInProcess.PAYMENT_CALLBACK_IN_PROCESS
        ) ||
        getCustomer?.operationsInProcess?.includes(
          operationsInProcess.SHIPMENT_PURCHASE_IN_PROGRESS
        )
      ) {
        setShowPaymentLoading(true);
      } else {
        if (initialPayDone.current) {
          setTimeout(() => setShowPaymentProcess(paymentSuccess.PAY_DONE), 2000);
          setTimeout(
            () => setShowPaymentProcess(paymentSuccess.SHIPMENT_PROGRESS),
            5000
          );
          setTimeout(() => setShowPaymentLoading(false), 8000);
          initialPayDone.current = false;
        }
      }
    }
  }, [group]);

  const callGetCustomer = () => {
    setTimeout(() => {
      dispatch(
        GetCustomer({
          username: encodeURIComponent(
            currentdetails && currentdetails.emailId
          ),
        })
      );
    }, 5000);
  };

  const line = () => {
    return (
      <Box
        sx={{
          background: "var(--primary_color)",
          borderRadius: "30px",
          height: "4px",
          width: "25%",
        }}
      ></Box>
    );
  };

  // Trigger GTM events for purchase success/failed.
  useEffect(() => {
    if (
      !showPaymentLoading &&
      (location?.state?.emailId || location?.state?.success) &&
      initialPurchase === "yes"
    ) {
      // gtmTagManager({
      //   event: gaCategory.mm_payment_success,
      // });
    } else if (
      !showPaymentLoading &&
      !location?.state?.success &&
      initialPurchase === "yes"
    ) {
      // gtmTagManager({
      //   event: gaCategory.mm_payment_fall_out,
      // });
    }
  }, [showPaymentLoading]);

  return showPaymentLoading === true ? (
    <Box
      sx={{
        width: { xs: "90%", sm: "90%", md: "45%", lg: "52%" },
        margin: "0px auto",
        textAlign: "center",
        padding: { xs: "10px", sm: "40px 0px 270px" },
        mt: "100px",
      }}
    >
      <Box
        sx={{
          background: "var(--white)",
          pt: "20px",
          px: "5px",
          // border: "1px solid var(--border_color)",
          borderRadius: "10px",
        }}
      >
        <Box>
          <Box
            key={`${showPaymentProcess}-${purchase_img?.data?.[0]?.attributes?.url}`}
            component={"img"}
            src={
              showPaymentProcess === paymentSuccess.PAY_PROGRESS
                ? purchase_img?.data?.[0]?.attributes?.url
                : showPaymentProcess === paymentSuccess.PAY_DONE
                ? purchase_img?.data?.[1]?.attributes?.url
                : purchase_img?.data?.[1]?.attributes?.url
            }
            alt={
              showPaymentProcess === paymentSuccess.PAY_PROGRESS
                ? purchase_img?.data?.[0]?.attributes?.alternativeText
                : showPaymentProcess === paymentSuccess.PAY_DONE
                ? purchase_img?.data?.[1]?.attributes?.alternativeText
                : purchase_img?.data?.[1]?.attributes?.alternativeText
            }
            width={"160px !important"}
            height="160px !important"
          />
          {/* <Typography
            sx={{
              fontSize: "36px",
              fontFamily: "var(--font_family_Light)",
              lineHeight: "30px",
              marginTop: "15px",
              color: "var(--text_color_8)",
            }}
          >
            {loader_heading}
          </Typography> */}
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: { xs: "18px", sm: "20px" },
              fontFamily: "var(--font_family_Semibold)",
              lineHeight: "27px",
              // mt: "15px",
              mb: "35px",
              p: { xs: "10px 10px 35px 10px", sm: "0 0 40px 0px" },
              color: 'var(--black)'
            }}
            dangerouslySetInnerHTML={{
              __html:
                showPaymentProcess === paymentSuccess.PAY_PROGRESS
                  ? pur_msg1
                  : showPaymentProcess === paymentSuccess.PAY_DONE
                  ? pur_msg2
                  : pur_msg3,
            }}
          ></Typography>
        </Box>
        {/* <Box
          sx={{
            display: "flex",
            gap: "5px",
            borderRadius: "30px",
          }}
        >
          {showPaymentProcess === paymentSuccess.PAY_PROGRESS && line()}
          {showPaymentProcess === paymentSuccess.PAY_DONE && line()}
          {showPaymentProcess === paymentSuccess.PAY_DONE && line()}
          {showPaymentProcess === paymentSuccess.SHIPMENT_PROGRESS && line()}
          {showPaymentProcess === paymentSuccess.SHIPMENT_PROGRESS && line()}
          {showPaymentProcess === paymentSuccess.SHIPMENT_PROGRESS && line()}
        </Box> */}
      </Box>
    </Box>
  ) : (
    <Box
      sx={{
        width: { xs: "90%", sm: "90%", md: "45%", lg: "52%" },
        margin: "0px auto",
        textAlign: "center",
        padding: { xs: "10px 10px 50px", sm: "40px 0px 270px" },
        mt: "100px",
      }}
    >
      {
        secondaryPaymentFail !== true &&
        (location?.state?.emailId || location?.state?.success) ? (
          <Box
            sx={{
              background: "var(--white)",
              pt: {xs: "20px", sm: "15px"},
              px: "5px",
              // border: "1px solid var(--border_color)",
              borderRadius: "10px",
            }}
          >
            <Box>
              <Box
                component={"img"}
                alt={"Success..."}
                src={purchase_img?.data?.[1]?.attributes?.url}
                // alt={tick_icon?.data?.attributes?.alternativeText}
                // src={content?.tick_icon?.data?.attributes?.url}
                width="160px !important"
                height="160px !important"
              />
              {/* <Typography
              sx={{
                fontSize: "36px",
                fontFamily: "var(--font_family_Light)",
                lineHeight: "30px",
                marginTop: "15px",
                color: "var(--text_color_8)",
              }}
            >
              {heading}
            </Typography> */}
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: "20px",
                  fontFamily: "var(--font_family_Semibold)",
                  lineHeight: "35px",
                  px: "10px",
                  // mt: "30px",
                  mb: "24px",
                  color: 'var(--black)'
                }}
                dangerouslySetInnerHTML={{
                  __html:
                    "Your order is confirmed and in safe hands. Thank you!",
                }}
              ></Typography>
            </Box>
            <Box
              sx={{
                // mb: {md: "35px"},
                paddingBottom: {xs: "30px", sm: "35px"}
              }}
            >
              <ButtonCust
                sx={{
                  fontSize: "16px",
                  lineHeight: "28px",
                  fontFamily: "var(--font_family_Medium)",
                  // textTransform: "uppercase !important",
                  "&:hover": {
                    backgroundColor: "var(--primary_color) !important",
                    border: "1px solid var(--primary_color) !important",
                  },
                  width: '250px'
                }}
                variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
                onClick={handleContinueToDashBoard}
              >
                {btn_txt}
              </ButtonCust>
            </Box>
            {/* <Box
              sx={{
                display: "flex",
                gap: "5px",
                borderRadius: "30px",
              }}
            >
              {line()}
              {line()}
              {line()}
              {line()}
            </Box> */}
          </Box>
        ) : null
      }
    </Box>
  );
};

export default T5PaymentLanding;
